import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { _CashRequestBudgetvdos } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { _DocumentFactory, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { DocumentViewer } from "../../../../../../theme/Component/DocumentViewer";


interface Props {
    Year: any;
    IDCashDeskAccount: any;
    BudgetIDStr: any;
}

export const CashRequestBudget = ({ Year, IDCashDeskAccount, BudgetIDStr }: Props) => {

    const cashrequest = useDataBean(_CashRequestBudgetvdos);
    const [docs, setDocs] = useState<any>([]);
    const single = Singleton.getInstance();
    const _documentos = useDataBean(_DocumentFactory);
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalverdoc, setModalverdoc] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [Year, IDCashDeskAccount, BudgetIDStr])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        cashrequest.instance.getCashRequestBudget(Year, IDCashDeskAccount, BudgetIDStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)

                }
            }
        )

    }
    const verDocumentos = () => {

        if (cashrequest.bean.FCIDDocument) {
            _documentos.instance.getPdfAccountantDocument(cashrequest.bean.FCIDDocument, null, cashrequest.bean.FCDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const create = () => {
        cashrequest.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        // cashrequest.instance.deleteSubProcess(cashrequest.bean).then(
        //     (resp: any) => {
        //         getLista();
        //         setModalC({ ...modalC, "view": false });
        //     }
        // )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        cashrequest.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'Solicitud de Caja Menor', property: 'IDCashRequest', visible: true },
        { title: 'Fecha Solicitud Caja Menor', property: 'CashRequestDate', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Valor', property: 'BudgetValue', visible: true },
        { title: 'Mnemonico', property: 'FCMnemonic', visible: true },
        { title: 'Consecutivo', property: 'FCConsecutive', visible: true },
        { title: 'Fecha Documento', property: 'FCDate', visible: true },
        { title: 'ID Factura Electrónica', property: 'IDUBLInvoice', visible: true },
        { title: 'Fecha Factura Electrónica', property: 'IssueDate', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Valores Reembolsados</label>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={cashrequest.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                    </div>
                </Modal>
                <div className="col-md-12">
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer

                                    list={docs}
                                    IDDocument={cashrequest.bean.FCIDDocument}
                                    Since={cashrequest.bean.FCDate}
                                />
                            </div>
                        </div>
                    </Modal>
                </div>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}